import { FooterSocialLinks } from "#/components/FooterSocialLinks";

import { FooterLegalNav } from "./FooterLegalNav";

export default function Footer() {
  return (
    <footer className="shrink-0 grow-0 border-t bg-background/80 px-4 py-4 text-muted-foreground backdrop-blur-md sm:py-6">
      <div className="mx-auto grid w-full max-w-[1080px] grid-cols-1 gap-2 text-sm sm:grid-cols-3 sm:items-center">
        <span className="text-center sm:text-left">
          &copy; {new Date().getFullYear()} Daily Wars
        </span>
        <div className="flex justify-center">
          <FooterSocialLinks />
        </div>
        <FooterLegalNav />
      </div>
    </footer>
  );
}
